import { enableProdMode, ErrorHandler, Injectable, importProvidersFrom } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule, SentryErrorHandler } from './app/app.module';
import { environment } from './environments/environment';
import { AppComponent } from './app/app.component';
import { MatSidenavModule } from '@angular/material/sidenav';
import { ImageCropperModule } from 'ngx-image-cropper';
import { provideAnimations } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app/app-routing.module';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { JWTInterceptor } from './app/global/http-interceptors/JWTInterceptor';
import { HTTP_INTERCEPTORS, withInterceptorsFromDi, provideHttpClient, HttpClientModule } from '@angular/common/http';
import { MyPaginatorIntl } from 'src/utilities/my_paginator_intl';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { MAT_DATE_LOCALE, MatNativeDateModule } from '@angular/material/core';
import { Integrations } from '@sentry/tracing';
import { environment as environment_1 } from 'src/environments/environment';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatDialogModule } from '@angular/material/dialog';
import { AccountService } from './app/pages/account/services/account.service';

const chunkFailedMessage = /Loading chunk [\d]+ failed/;



if (environment.production) {
	enableProdMode();
}

/** Function to get locale from URL path */
function getLocale(accountService: AccountService): string {
    const lang = accountService.getLocaleId();
    
	const supportedLangs: Record<string, string> = {
        bg: 'bg-BG', // Bulgarian
        cs: 'cs-CZ', // Czech
        da: 'da-DK', // Danish
        de: 'de-DE', // German
        el: 'el-GR', // Greek
        en: 'en-US', // English
        'en-base': 'en-US', // Base English
        es: 'es-ES', // Spanish
        fi: 'fi-FI', // Finnish
        fr: 'fr-FR', // French
        hr: 'hr-HR', // Croatian
        hu: 'hu-HU', // Hungarian
        it: 'it-IT', // Italian
        nl: 'nl-NL', // Dutch
        pl: 'pl-PL', // Polish
        pt: 'pt-PT', // Portuguese
        ro: 'ro-RO', // Romanian
        sk: 'sk-SK', // Slovak
        sv: 'sv-SE', // Swedish
        uk: 'uk-UA', // Ukrainian
    };
	  return supportedLangs[lang] || 'en-US'; 
	  
}

bootstrapApplication(AppComponent, {
    providers: [
        importProvidersFrom(BrowserModule.withServerTransition({ appId: 'serverApp' }), AppRoutingModule, ImageCropperModule, MatNativeDateModule, MatSidenavModule, MatSnackBarModule, MatDialogModule, HttpClientModule),
        {
            provide: ErrorHandler,
            useClass: SentryErrorHandler,
        },
        {
            provide: MAT_DATE_LOCALE,
            useFactory: (accountService: AccountService) => getLocale(accountService),
			deps: [AccountService],
        },
        {
            provide: MatPaginatorIntl,
            useValue: MyPaginatorIntl(),
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: JWTInterceptor,
            multi: true,
        },
        provideAnimations(),
        provideHttpClient(withInterceptorsFromDi())
    ]
})
	.catch((err) => console.error(err));
